import { Status } from '../constants/FormConstants';
import { BLUE, BROWN, GREEN, RED } from '../constants/ColorConstants';

// TODO - Can we change this below to be used from a standard location?
export const layoutConstants = {
    LAYOUT_MIN_MOBILE_WIDTH: 360,
    LAYOUT_MIN_TABLET_WIDTH: 600,
    CUSTOM_LAYOUT_MIN_TABLET: 768,
    LAYOUT_MAX_TABLET_WIDTH: 599,
    CUSTOM_LAYOUT_MAX_TABLET: 767,
};

export const isDesktop = (width: number) => {
    return width > layoutConstants.CUSTOM_LAYOUT_MAX_TABLET;
};

export const formatCapitalizeFirstLetters = (input: string) => {
    let formattedString = input.replace(/_/g, ' ');
    formattedString = formattedString
        .split(/\s+/)
        .map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
    return formattedString;
};

export const getColorBasedOnStatus = (status: string) => {
    switch (formatCapitalizeFirstLetters(status)) {
        case Status.Current:
            return GREEN;
        case Status.Expired:
            return RED;
        case Status.Hiatus:
            return BROWN;
        case Status.Waitlist:
            return BLUE;
        default:
            return RED;
    }
};
